"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flat = flat;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

const defaultShouldFlat = item => typeof item !== 'string' && (0, _iterable.isIterable)(item);

function* flatInternal(shouldFlat, depth, currentDepth, source) {
  for (const item of source) {
    if (currentDepth < depth && shouldFlat(item)) {
      yield* flatInternal(shouldFlat, depth, currentDepth + 1, item);
    } else {
      yield item;
    }
  }
}

function flat(source, shouldFlat = defaultShouldFlat, depthOrOptions = 1) {
  let depth = depthOrOptions;

  if (depthOrOptions && typeof depthOrOptions === 'object') {
    ({
      shouldFlat = defaultShouldFlat,
      depth = 1
    } = depthOrOptions);
  }

  return flatInternal(shouldFlat, depth, 0, source);
}

var _default = (0, _iterable.iterableCurry)(flat, {
  minArgs: 0,
  maxArgs: 2
});

exports.default = _default;